import { FC, useRef } from 'react';
import { Button } from 'primereact/button';
import { OverlayPanel } from 'primereact/overlaypanel';

const ClassesRosterCleverInfo: FC = () => {
  const panel = useRef<OverlayPanel>(null);

  return (
    <>
      <Button
        label="Clever"
        icon="nc_icon-nc_info icon-sm"
        iconPos="right"
        rounded
        className="nc_clever-btn"
        aria-label="About Clever Sync"
        onClick={event => panel.current?.toggle(event)}
      />
      <OverlayPanel
        ref={panel}
        showCloseIcon
        dismissable
        className="nc_clever-info-panel"
        style={{ maxWidth: '20rem' }}
      >
        <p className="font-semibold mt-0">Your classes are managed by Clever Sync.</p>
        <p className="mb-2">Clever Sync does not support:</p>
        <ul className="m-0 pl-4 flex flex-column gap-md">
          <li>
            <b>Roster Changes or Class Edits</b> - all changes and updates must go through Clever.
          </li>
          <li>
            <b>Class Creation</b> - If you create classes in Roadmaps, they won&apos;t be synced to Clever, and could be
            subject to deactivation.
          </li>
        </ul>
      </OverlayPanel>
    </>
  );
};

export default ClassesRosterCleverInfo;
